
/* injects from baggage-loader */

"use strict";

export default class ProductController {
  constructor($log, Navigation, Alerts) {
    "ngInject";

    this.$log = $log;
    this.Navigation = Navigation;
    this.alerts = Alerts;
  }

  $onInit() {
    this.$log.log(this.product.toJSON());

    // Hide Variants menu bar item
    if (this.product.get("parent")) {
      this.alerts.setLocal({ type: 'info', msg: 'Viewing serial number variant', stickyParent: true });
      this.Navigation.removeMenuItem("Variants");
    } else {
      this.alerts.clearLocal();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/product/product.controller.js